import { createTheme } from "@mui/material/styles";

const Theme = createTheme({
    palette: {
        primary: {
            main: '#4b9afe',
        }
    },
    typography: {
        "fontFamily": "IRANSansX"
    }
})
export default Theme
